import * as React from 'react'

import { useData } from './hooks'
import { ClosedLostForm } from './ClosedLostForm'
import { LoadingSpinner } from '@sales-center/components'
import { ENTITY_TYPES, SOLD_SERVICE_STATUS } from '@sales-center/common'

import DialogContent from '@mui/material/DialogContent'
import Box from '@mui/material/Box'
import Alert from '@mui/material/Alert'

type Props = {
  entityId: number
  onClose: () => void
  salesFunnelId: number
  assigneeId: string | null
  entityType: ENTITY_TYPES
  soldServiceStatus?: SOLD_SERVICE_STATUS
}

export function ClosedLostDialogContent(props: Props) {
  const {
    onClose,
    entityId,
    entityType,
    salesFunnelId,
    assigneeId,
    soldServiceStatus,
  } = props

  const {
    status,
    loading,
    stageId,
    reasonDetail,
    cancelReasons,
    hasFreeEstimates,
  } = useData({
    entityId,
    entityType,
    salesFunnelId,
    soldServiceStatus,
  })

  return (
    <>
      {loading && (
        <DialogContent>
          <Box minHeight="48px">
            <LoadingSpinner />
          </Box>
        </DialogContent>
      )}

      {status === 'fail' && (
        <DialogContent>
          <Alert severity="error">Error loading reasons</Alert>
        </DialogContent>
      )}

      {status === 'success' && !loading && reasonDetail && (
        <ClosedLostForm
          onClose={onClose}
          entityId={entityId}
          entityType={entityType}
          reasonDetail={reasonDetail}
          salesFunnelStageId={stageId}
          cancelReasons={cancelReasons}
          hasFreeEstimates={hasFreeEstimates}
          assigneeId={assigneeId}
          soldServiceStatus={soldServiceStatus}
        />
      )}
    </>
  )
}
